<div class="service-category-group">
  <h2 [ngClass]="{ 'service-category-heading': true, expanded: !detailsHidden }">
    {{ serviceCategory.name }}
  </h2>
  <div [ngClass]="{ hidden: detailsHidden, expanded: !detailsHidden }" class="service-category-details">
    <hcf-person-detail
      [person]="personDetail"
      *ngFor="let personDetail of peopleBySerivceCategory"
      class="person-detail"></hcf-person-detail>
  </div>
</div>
